export enum BusinessType {
  'visa' = 'visa',
  'dbs' = 'dbs',
  aeonStampRewards2023 = 'aeon-stamp-rewards-2023',
}
